







import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { editor, languages, KeyMod, KeyCode } from 'monaco-editor'
import { algorithmCodeGlobals } from '@/utils/constants'

@Component
export default class CodeEditor extends Vue {
  @Prop(String) readonly value!: string
  @Prop(String) readonly extraGlobals!: string
  editor?: editor.IStandaloneCodeEditor

  @Watch('extraGlobals')
  handleExtraGlobalsChanged () {
    this.setupJavascriptDefaults()
  }

  @Watch('value')
  handleValueChanged (value: string, prevValue: string) {
    if (!this.editor || value === prevValue) {
      return
    }
    this.editor.setValue(this.value)
  }

  handleCodeChanged () {
    if (!this.editor) {
      return
    }
    this.$emit('input', this.editor.getValue())
  }

  mounted () {
    this.setupJavascriptDefaults()
    this.editor = editor.create(
      this.$refs.monacoContainer as HTMLElement,
      {
        value: this.value,
        language: 'javascript',
        theme: 'vs-dark',
        tabSize: 2,
        automaticLayout: true
      }
    )
    this.editor.addAction({
      id: 'FULLSCREEN',
      label: 'Toggle Fullscreen',
      keybindings: [KeyMod.CtrlCmd | KeyCode.F11],
      run: () => {
        const element = this.$refs.monacoContainer as HTMLElement
        if (document.fullscreenElement) {
          element.style.height = ''
          element.style.width = ''
          document.exitFullscreen()
        } else {
          element.requestFullscreen()
          element.style.height = '100vh'
          element.style.width = '100vw'
        }
      }
    })
    this.editor.onDidBlurEditorText(this.handleCodeChanged)
  }

  setupJavascriptDefaults () {
    languages.typescript.javascriptDefaults.setExtraLibs([
      {
        content: algorithmCodeGlobals
      },
      {
        content: this.extraGlobals
      }
    ])
  }
}

